// /b/:id/settings — full settings screen with delete flow.

import { useNavigate, useOutletContext } from "react-router-dom";
import type { BabyShellContext } from "./BabyShell";
import { SettingsView } from "../components/SettingsView";
import { supabase } from "../lib/supabase";
import { lastUsedBabyId } from "../lib/babyId";
import { useAuth } from "../lib/AuthContext";
import { useT } from "../lib/LocaleContext";

export function Settings() {
  const { baby, role, updateBabyPhoto, updateBabyName, updateBabyDefaults } = useOutletContext<BabyShellContext>();
  const navigate = useNavigate();
  const { user } = useAuth();
  const t = useT();

  async function handleDelete() {
    const { error } = await supabase.from("babies").delete().eq("id", baby.id);
    if (error) {
      alert(t.settings.deleteFailed(error.message));
      return;
    }
    // Drop the cached last-used baby id so we don't loop back to a tombstone.
    // "/" re-decides: another baby on the account, the picker, or setup.
    lastUsedBabyId.clear(user?.id);
    navigate("/", { replace: true });
  }

  return (
    <SettingsView
      baby={baby}
      role={role}
      onPhotoChange={updateBabyPhoto}
      onNameChange={updateBabyName}
      onDefaultsChange={updateBabyDefaults}
      onDelete={handleDelete}
    />
  );
}
